import { InjectionToken } from '@angular/core';

export const SOFTLINE_FEATURE_UPDATED_ARTICLE_LABEL_PRINT =
  'wws/updated-article-label-print';

export interface UpdatedArticleLabelPrintConfig {
  route?: string;
}

export const SOFTLINE_CONFIG_UPDATED_ARTICLE_LABEL_PRINT =
  new InjectionToken<UpdatedArticleLabelPrintConfig>(
    'SOFTLINE_CONFIG_UPDATED_ARTICLE_LABEL_PRINT'
  );
